import { createFileRoute } from "@tanstack/react-router";
import { getAllPosts } from "@/lib/posts.functions";
import { TAGS, tagLabel } from "@/lib/tags";
import { pageTitle } from "@/lib/brand";
import { absUrl, hreflangLinks } from "@/lib/seo";
import { PageIntro, PageSection, LinkRows, type RowItem } from "@/components/site/page";

const DESC =
  "Yapay zeka, iklim ve insan geleceği yazılarının tema tema koleksiyonları: veri merkezleri, enerji, yeşil aklama, yalnızlık ve daha fazlası.";

export const Route = createFileRoute("/etiket/")({
  head: () => ({
    meta: [
      { title: pageTitle("Etiketler", "tr") },
      { name: "description", content: DESC },
      { property: "og:title", content: "Etiketler — Akıllı Sürdürülebilirlik" },
      { property: "og:description", content: DESC },
      { property: "og:url", content: absUrl("/etiket") },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [
      { rel: "canonical", href: absUrl("/etiket") },
      ...hreflangLinks("/etiket", "/topics"),
    ],
  }),
  loader: async () => {
    const posts = await getAllPosts({ data: { lang: "tr" } });
    const counts: Record<string, number> = {};
    for (const p of posts) for (const t of p.tags ?? []) counts[t] = (counts[t] ?? 0) + 1;
    return { counts };
  },
  component: TagIndex,
});

function TagIndex() {
  const { counts } = Route.useLoaderData();
  const list = Array.from(new Set([...TAGS.map((t) => t.slug), ...Object.keys(counts)]))
    .filter((slug) => (counts[slug] ?? 0) > 0)
    .sort((a, b) => (counts[b] ?? 0) - (counts[a] ?? 0));

  const items: RowItem[] = list.map((slug) => {
    const tag = TAGS.find((t) => t.slug === slug);
    const label = tag?.tr ?? tagLabel(slug);
    const description = tag?.descTr ?? `“${label}” etiketiyle işaretlenmiş yazılar.`;
    return {
      key: slug,
      to: "/etiket/$slug",
      params: { slug },
      title: label,
      excerpt: description,
      meta: `${counts[slug]} yazı`,
    };
  });

  return (
    <>
      <PageIntro crumbs={[{ label: "Etiketler" }]} kicker="Temalar" title="Etiketler" lede={DESC} />
      <PageSection>
        <LinkRows items={items} />
      </PageSection>
    </>
  );
}
